var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"panel-ring"},[_vm._m(0),_c('div',{staticClass:"panel-ring-content"},[_c('key-value-unit',{attrs:{"title":"监测状态","value":_vm.placeholderText(_vm.monitorStatusStr)}})],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"panel-ring-top"},[_c('p',{staticClass:"panel-ring-top-title"},[_vm._v("主设备")])])
}]

export { render, staticRenderFns }